import { Component, inject, Input } from "@angular/core";
import { DashboardsService } from "@app/shared";
import { IBaseCard } from "@app/views-interfaces";

@Component({
    selector: "wk-search-result",
    templateUrl: "./search-result.component.html",
    styleUrl: "./search-result.component.scss",
    standalone: false,
    host: { class: "wk-search-result fancy-scrollbar" },
})
export class SearchResultComponent {
    readonly dashboardsService = inject(DashboardsService);
    @Input() cards: IBaseCard[] = [];
    @Input() showLoader: boolean = false;
}
